// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PickUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 56"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M56 38.3l-14.9 8c-.8-1.1-2.1-1.8-3.4-1.8h-.4L16.5 6c-.7-1.3-2-2.4-3.4-2.8-1.4-.4-3-.3-4.3.4L3.7 6.4c-.7.4-.9 1.2-.6 1.9.4.6 1.2.9 1.9.5L10.1 6c.7-.4 1.5-.4 2.2-.2.7.3 1.4.8 1.7 1.5l20.7 38.5c-1.3 1.3-1.7 3.3-.8 5 .7 1.4 2.2 2.2 3.7 2.2.7 0 1.4-.2 2-.5 1-.5 1.7-1.4 2-2.5.1-.3.1-.6.2-1l15.4-8.3c.7-.4.9-1.2.6-1.9-.3-.6-1.1-.8-1.8-.5zM39.1 49.2c-.1.4-.4.7-.7.9-.7.4-1.6.1-2-.6-.4-.7-.1-1.6.6-2 .2-.1.5-.2.7-.2.5 0 1 .3 1.3.8.2.4.2.8.1 1.1z"/><path d="M60.9 31.3L52.6 16c-.4-.7-1.2-.9-1.9-.6l-5 2.7-5.9-10.8c-.1-.3-.4-.5-.8-.6-.3-.1-.7-.1-1 .1l-12.8 6.9c-.3.2-.6.5-.7.8-.1.4-.1.7.1 1.1l6.7 11.9 8.3 15.3c.2.5.7.7 1.2.7.2 0 .4-.1.7-.2l18.9-10.2c.3-.2.6-.5.7-.8 0-.3-.1-.6-.2-1zM27.7 15.5l10.4-5.6 5.2 9.6L33 25l-5.3-9.5zm13.6 24.8l-7-12.9 11.5-6.2 5-2.7 7 12.9-16.5 8.9z"/><path d="M38.7 13.3c-.4-.7-1.2-.9-1.9-.6l-6 3.3c-.7.4-.9 1.2-.6 1.9.2.5.7.7 1.2.7.2 0 .4-.1.7-.2l6-3.3c.7-.3.9-1.2.6-1.8zM49 22.6l-10.3 5.6c-.7.4-.9 1.2-.6 1.9.2.5.7.7 1.2.7.2 0 .4-.1.7-.2L50.3 25c.7-.4.9-1.2.6-1.9-.4-.6-1.3-.8-1.9-.5z"/></svg>;
};

export default React.memo(PickUp);
